import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { DatabaseService } from 'src/_services/DatabaseService';
import { Router } from '@angular/router';

import { DialogComponent } from 'src/app/dialog.component';
import { ToastrManager } from 'ng6-toastr-notifications';
import { sessionStorage } from 'src/app/localstorage.service';
import { log } from 'util';
import * as moment from 'moment';

@Component({
  selector: 'app-contractor-meet-status-modal',
  templateUrl: './contractor-meet-status-modal.component.html'
})
export class ContractorMeetStatusModalComponent implements OnInit {
  savingFlag: boolean = false;
  statusdata: any = {};
  newEventData: any = {};
  today_date:any
  data1: any;
  loader:boolean=false;
  datanotofound:boolean=false;
  Event_id:any={}
  login_data: any = {};
  user_details_count:any=[];
  selectedStatus: any = {};
  from: any = '';
  current_year: any;
  date: any;
  assign_module_data: any = [];
  assign_module_data2: any = [];
  monthNames: string[];
  currentMonth: any;
  currentMonth1: any;
  skLoading: boolean =false;


  constructor(@Inject(MAT_DIALOG_DATA) public data, public session: sessionStorage, public serve: DatabaseService, public dialog: MatDialog, public rout: Router, public alert: DialogComponent, public toast: ToastrManager, public dialogRef: MatDialogRef<ContractorMeetStatusModalComponent>) {
    console.log(data)
    console.log(data.event_id);
    this.date = new Date();
    this.data.eventBudget=this.data.givenBudget
    this.monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    this.currentMonth = this.monthNames[this.date.getMonth()];
    this.today_date = new Date().toISOString().slice(0, 10);
    this.Event_id=data.event_id
    this.data.month=data.month
    this.data.month=this.currentMonth
    this.currentMonth1 =this.date.getMonth() + 1;
    console.log(this.currentMonth1);
    this.data1 = data;
    this.current_year = this.date.getFullYear();
    this.data.year=this.current_year;
    console.log(this.current_year);

    this.login_data = this.session.getSession();
    this.login_data = this.login_data.value;
    this.login_data = this.login_data.data;
    this.from = data.from;
    // this.getDetails();
    if(this.from=='dropdownData')
    {
this.getDropDownList();

    }
    

  }

  ngOnInit() {
  }
  updateDetails() {
    if(this.statusdata.status=='Completed' && !this.statusdata.actualAmt){
      this.toast.errorToastr('Amount is mandatory');
      return false;
    }
    if (this.statusdata.completeDate) {
      this.statusdata.completeDate = moment(this.statusdata.completeDate).format('YYYY-MM-DD');
      this.statusdata.completeDate = this.statusdata.completeDate;
    }
    this.savingFlag = true;
    this.statusdata.status_changed_by = this.login_data.id;
    this.statusdata.eventId = this.data1.id;

    this.serve.post_rqst(this.statusdata, "Event/eventHold").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.dialogRef.close(true);
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      } else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }))
  }

  close(){
    this.dialogRef.close();
  }

  EventUpdate() {
    this.dialogRef.close(true);
    this.savingFlag = true;
    const requestData = {

      newEventDate: this.newEventData.newEventDate,
      reason: this.newEventData.reason,
      Event_id: this.Event_id

  };
    this.serve.post_rqst(requestData, "Event/postponeEvent").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.dialogRef.close(true);
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      } else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }))

  }

  MobileNumber(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) { event.preventDefault(); }

  }

  updatePerBudget() {
    this.savingFlag = true;
    this.statusdata.status_changed_by = this.login_data.id;
    this.statusdata.id = this.data1.id;
    this.statusdata.per_plumber_budget = this.data.per_plumber_budget;
    this.serve.post_rqst(this.statusdata, "Event/perPlumberBudgets").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.dialogRef.close(true);
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      } else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }))
  }


  updateGivenBudget1() {
    this.savingFlag = true;
    if(this.data.event_id){
      console.log('====================================');
      console.log(this.data.event_id);
      console.log('====================================');
    }else{
      console.log(this.data.event_id);
      this.data.event_id=0;
    }
    if(this.data.budgetUpdateDate){
      this.data.budgetUpdateDate = moment(this.data.budgetUpdateDate).format('YYYY-MM-DD');
    }
    this.serve.post_rqst({'year':this.data.year,'userId':this.data.user_id,'eventBudgetId':this.data.event_id,'budgetUpdateDate':this.data.budgetUpdateDate,'eventBudget':this.data.eventBudget,'month':this.currentMonth1}, "Event/updateEventBudget").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.dialogRef.close(true);
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      } else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }))
  }

  // getDetails(){
  //   this.loader = true;
  //   this.serve.post_rqst({'eventBudgetId':this.data.event_id,'userId':this.data.user_id}, "Event/budgetLogs")
  //   .subscribe((result => {
  //     if(result['statusCode']==200){
  //     this.user_details_count  = result['logList'];
  //     this.loader = false;
  //     if (this.user_details_count.length == 0) {
  //       this.datanotofound=true;
  //     }else{
  //       this.datanotofound=false;
  //       this.loader = false;
  //     }

  //     }else{
  //       this.toast.errorToastr(result['statusMsg'])
  //     }
  //   }))
  // }

    assign_module(event, index) {
    if (event.checked) {
      this.assign_module_data[index]['visibilityFlag'] = '1';
    }
    else {
      this.assign_module_data[index]['visibilityFlag'] = '0';
    }
  }

  getDropDownList() {
    this.skLoading = true;
    this.serve.post_rqst({ }, "Event/getEventTypeList").subscribe(result => {
      if (result['statusCode'] == 200) {
        this.skLoading = false;
        this.assign_module_data = result['result'];
        this.assign_module_data2 = result['result'];
      } else {
        this.skLoading = false;
        this.toast.errorToastr(result['statusMsg']);
      }
    }, err => {
      this.skLoading = false;
      this.toast.errorToastr('Something went wrong');
    });
  }

  updateDropDown(){
    this.savingFlag = true;
 this.serve.post_rqst({ data:this.assign_module_data}, "Event/getEventTypeListUpdate").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.dialogRef.close(true);
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      } else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }))
  }
}
